const yardCity = [
  { key: 'KISARAZU: ECL :INTER OCEAN', port: 'KISARAZU', yard: 'ECL' },
  { key: 'OTHER: AUTO_SELECTION', port: 'OTHER', yard: 'AUTO_SELECTION' },
  { key: 'YOKOHAMA: DAITO & MOANABLUE', port: 'YOKOHAMA', yard: 'DAITO' },
  { key: 'MOJI: ECL & MOANABLUE', port: 'MOJI', yard: 'ECL' },
  {
    key: 'KOBE: NIHON TRANS & MOANABLUE',
    port: 'KOBE',
    yard: 'NIHON TRANS & MOANABLUE',
  },
  { key: 'MOJI:AH:GENEC&AUTOHUB', port: 'MOJI', yard: 'GENEQ & AUTOHUB' },
  { key: 'YOKOHAMA: ECL(NON-DRIVABLE)', port: 'YOKOHAMA', yard: 'ECL' },
  { key: 'HAKATA: SYNC HAKOZAKI', port: 'HAKATA', yard: 'SYNC HAKOZAKI' },
  { key: 'OTHER: SHUMAKA', port: 'OTHER', yard: 'SHUMAKA' },
  { key: 'KISARAZU: ECL', port: 'KISARAZU', yard: 'ECL' },
  {
    key: 'OSAKA(INSPECTION)-KEIHINKOUN: QI: Inspection',
    port: 'OSAKA(INSPECTION)-KEIHINKOUN',
    yard: 'QI: Inspection',
  },
  {
    key: 'OSAKA(INSPECTION): QI: Inspection',
    port: 'OSAKA(INSPECTION)',
    yard: 'QI: Inspection',
  },
  { key: 'OTHER: ZERO: CS', port: 'OTHER', yard: 'ZERO: CS' },
  {
    key: 'KOBE(INSPECTION): QI: Inspection',
    port: 'KOBE(INSPECTION)',
    yard: 'QI: Inspection',
  },
  { key: 'OTHER: IP: Inspection', port: 'OTHER', yard: 'IP: Inspection' },
  { key: 'OTHER: OT: Other', port: 'OTHER', yard: 'OT: Other' },
  {
    key: 'KISARAZU: NIPPON LOGISTIC SERVICES',
    port: 'KISARAZU',
    yard: 'NIPPON LOGISTIC SERVICES',
  },
  { key: 'OTHER: RS: Resale', port: 'OTHER', yard: 'RS: Resale' },
  { key: 'OSAKA: YUUKOSHA', port: 'OSAKA', yard: 'YUUKOSHA' },
  { key: 'OSAKA: KOJITSU', port: 'OSAKA', yard: 'KOJITSU' },
  {
    key: 'NAGOYA(YATOMI): FLASH RISE & MOANABLUE',
    port: 'NAGOYA(YATOMI)',
    yard: 'FLASH RISE & MOANABLUE',
  },
  { key: 'KAWASAKI: SYNC(CHIDORI)', port: 'KAWASAKI', yard: 'SYNC(CHIDORI)' },
  { key: 'OTARU: JAL OTARU', port: 'OTARU', yard: 'JAL OTARU' },
  { key: 'OSAKA:FUJIWARA&AUTOHUB', port: 'OSAKA', yard: 'AUTOHUB' },
  { key: 'NAGOYA: NR JAPAN', port: 'NAGOYA', yard: 'NR JAPAN' },
  {
    key: 'KAWASAKI: SYNC(HIGASHI-OGIJIMA)',
    port: 'KAWASAKI',
    yard: 'SYNC(HIGASHI-OGIJIMA)',
  },
  { key: 'KISARAZU: ECL&MOANA', port: 'KISARAZU', yard: 'ECL & MOANA' },
  { key: 'KOBE: FUJIWARA', port: 'KOBE', yard: 'FUJIWARA' },
  { key: 'KOBE: KEIHIN', port: 'KOBE', yard: 'KEIHIN' },
  {
    key: 'YOKOHAMA: SUN PHOENIX&AUTOHUB(DAIKOKU)',
    port: 'YOKOHAMA',
    yard: 'SUN PHOENIX & AUTOHUB(DAIKOKU)',
  },
  {
    key: 'YOKOHAMA: ORIENT KEIHIN(DAIKOKU)',
    port: 'YOKOHAMA',
    yard: 'ORIENT KEIHIN(DAIKOKU)',
  },
  { key: 'NAGOYA: FUJI TRANS', port: 'NAGOYA', yard: 'FUJI TRANS' },
  {
    key: 'OSAKA: SYNC OSAKA(ISSHIN)',
    port: 'OSAKA',
    yard: 'ISSHIN SHOJI & SYNC OSAKA',
  },
  {
    key: 'MOJI: KS MARITIME(SHINMOJI)',
    port: 'MOJI',
    yard: 'KS MARITIME(SHINMOJI)',
  },
  {
    key: 'YOKOHAMA: SUN PHOENIX(DAIKOKU)',
    port: 'YOKOHAMA',
    yard: 'SUN PHOENIX(DAIKOKU)',
  },
  { key: 'KAWASAKI: YOKOLOGI', port: 'KAWASAKI', yard: 'YOKOLOGI' },
  { key: 'YOKOHAMA: US: US Logi', port: 'YOKOHAMA', yard: 'US: US Logi' },
  { key: 'YOKOHAMA: ECL', port: 'YOKOHAMA', yard: 'ECL' },
  { key: 'TOYAMA: JAL TOYAMA', port: 'TOYAMA', yard: 'JAL TOYAMA' },
  { key: 'TOYAMA: DV MOTORS', port: 'TOYAMA', yard: 'DV MOTORS' },
  { key: 'TOYAMA: AKSYS', port: 'TOYAMA', yard: 'AKSYS' },
  { key: 'OTARU: AN: Akebono', port: 'OTARU', yard: 'AN: Akebono' },
  {
    key: 'OSAKA: SYNC OSAKA',
    port: 'OSAKA',
    yard: 'SHINKYO UNYU & SYNC OSAKA',
  },
  { key: 'OSAKA: FUJIWARA', port: 'OSAKA', yard: 'FUJIWARA' },
  {
    key: 'OSAKA: ECL & MOANABLUE (CLOSED)',
    port: 'OSAKA',
    yard: 'ECL & MOANABLUE',
  },
  { key: 'OSAKA: ECL', port: 'OSAKA', yard: 'ECL' },
  { key: 'NODA: JC-NODA', port: 'NODA', yard: 'JC NODA YARD' },
  {
    key: 'NAGOYA: SYNC NAGOYA',
    port: 'NAGOYA',
    yard: 'PROSPERITY&SYNC NAGOYA',
  },
  { key: 'NAGOYA: NAGASE JIDOUSYA', port: 'NAGOYA', yard: 'NAGASE JIDOUSYA' },
  { key: 'NAGOYA: MITSUI SOKO', port: 'NAGOYA', yard: 'MITSUI SOKO' },
  {
    key: 'NAGOYA: KAMIGUMI & AUTOHUB',
    port: 'NAGOYA',
    yard: 'KAMIGUMI & AUTOHUB',
  },
  { key: 'NAGOYA: FLASH RISE', port: 'NAGOYA', yard: 'FLASH RISE' },
  { key: 'NAGOYA: DAIEI', port: 'NAGOYA', yard: 'DAIEI' },
  { key: 'MOJI: ECL', port: 'MOJI', yard: 'ECL' },
  { key: 'MITO: IT: Indus Trading', port: 'MITO', yard: 'IT: Indus Trading' },
  { key: 'MAIZURU: MW-LINE', port: 'MAIZURU', yard: 'MW-LINE' },
  { key: 'MAIZURU: IINO KOUN', port: 'MAIZURU', yard: 'IINO KOUN' },
  { key: 'KOBE: SUN PHOENIX', port: 'KOBE', yard: 'SUN PHOENIX' },
  { key: 'KOBE: JFA', port: 'KOBE', yard: 'JFA' },
  {
    key: 'KOBE: FUJI TECHNO TRANS & MOANABLUE( CLOSED )',
    port: 'KOBE',
    yard: 'FUJI TECHNO TRANS & MOANABLUE( CLOSED )',
  },
  {
    key: 'KOBE: FUJI TECHNO TRANS( NOT USING NOW )',
    port: 'KOBE',
    yard: 'FUJI TECHNO TRANS',
  },
  { key: 'KOBE: ECL & FROM J', port: 'KOBE', yard: 'ECL & FROM J' },
  { key: 'KOBE: ECL', port: 'KOBE', yard: 'ECL' },
  { key: 'KISARAZU: JFA', port: 'KISARAZU', yard: 'JFA' },
  {
    key: 'KAWASAKI: SUN PHOENIX(UKISHIMA)',
    port: 'KAWASAKI',
    yard: 'SUN PHOENIX(UKISHIMA)',
  },
  {
    key: 'KAWASAKI: SUN PHOENIX(HIGASHI-OGIJIMA)',
    port: 'KAWASAKI',
    yard: 'SUN PHOENIX(HIGASHI-OGIJIMA)',
  },
  {
    key: 'KAWASAKI: KZ: Kazz Logistics',
    port: 'KAWASAKI',
    yard: 'KZ: Kazz Logistics',
  },
  { key: 'KAWASAKI: ECL 平置', port: 'KAWASAKI', yard: 'ECL HIRAOKI' },
  { key: 'KAWASAKI: ECL & JAL', port: 'KAWASAKI', yard: 'ECL & JAL' },
  { key: 'KASHIWA: SUN PHOENIX', port: 'KASHIWA', yard: 'SUN PHOENIX' },
  { key: 'KARATSU: JAL KARATSU', port: 'KARATSU', yard: 'JAL KARATSU' },
  { key: 'HITACHINAKA: FWT', port: 'HITACHINAKA', yard: 'FWT' },
  { key: 'HAKATA: SYNC HAKATA', port: 'HAKATA', yard: 'SYNC HAKATA' },
  { key: 'HAKATA: ECL', port: 'HAKATA', yard: 'ECL' },
  { key: 'HAKATA: AL: Auto Logi', port: 'HAKATA', yard: 'AL: Auto Logi' },
  { key: 'FUKUI: FF: Fukui Futo', port: 'FUKUI', yard: 'FF: Fukui Futo' },
];
const ID_MAPPING = [
  { id: 127, value: 127 },
  { id: 128, value: 127 },
  { id: 129, value: 127 },
  { id: 130, value: 127 },
  { id: 131, value: 127 },
  { id: 132, value: 127 },
  { id: 134, value: 134 },
  { id: 135, value: 134 },
  { id: 136, value: 134 },
  { id: 137, value: 134 },
  { id: 138, value: 134 },
  { id: 139, value: 134 },
  { id: 140, value: 134 },
  { id: 141, value: 134 },
  { id: 142, value: 134 },
  { id: 143, value: 134 },
  { id: 144, value: 134 },
  { id: 145, value: 134 },
  { id: 146, value: 134 },
  { id: 147, value: 134 },
  { id: 148, value: 134 },
  { id: 149, value: 134 },
  { id: 150, value: 134 },
  { id: 151, value: 134 },
  { id: 152, value: 134 },
  { id: 153, value: 134 },
  { id: 154, value: 134 },
  { id: 155, value: 134 },
  { id: 156, value: 134 },
  { id: 157, value: 134 },
  { id: 158, value: 134 },
  { id: 159, value: 134 },
  { id: 160, value: 134 },
  { id: 161, value: 134 },
  { id: 162, value: 134 },
  { id: 163, value: 134 },
  { id: 164, value: 134 },
  { id: 165, value: 134 },
  { id: 166, value: 134 },
  { id: 167, value: 134 },
  { id: 168, value: 134 },
  { id: 169, value: 134 },
  { id: 172, value: 134 },
  { id: 173, value: 134 },
  { id: 174, value: 134 },
  { id: 175, value: 134 },
  { id: 176, value: 134 },
  { id: 177, value: 134 },
  { id: 182, value: 134 },
  { id: 183, value: 134 },
  { id: 184, value: 134 },
  { id: 185, value: 134 },
  { id: 186, value: 134 },
  { id: 187, value: 134 },
  { id: 188, value: 134 },
  { id: 189, value: 134 },
  { id: 190, value: 134 },
  { id: 191, value: 134 },
  { id: 192, value: 134 },
  { id: 193, value: 134 },
  { id: 194, value: 134 },
  { id: 195, value: 134 },
  { id: 196, value: 134 },
  { id: 197, value: 134 },
  { id: 198, value: 134 },
  { id: 199, value: 134 },
  { id: 200, value: 134 },
  { id: 201, value: 134 },
  { id: 202, value: 134 },
  { id: 203, value: 134 },
  { id: 204, value: 134 },
  { id: 205, value: 134 },
  { id: 206, value: 134 },
  { id: 207, value: 134 },
  { id: 208, value: 134 },
  { id: 209, value: 134 },
  { id: 210, value: 134 },
  { id: 211, value: 134 },
  { id: 212, value: 134 },
  { id: 213, value: 134 },
  { id: 214, value: 134 },
  { id: 215, value: 134 },
  { id: 216, value: 134 },
  { id: 217, value: 134 },
  { id: 218, value: 134 },
  { id: 219, value: 134 },
  { id: 220, value: 134 },
  { id: 221, value: 134 },
  { id: 222, value: 134 },
  { id: 223, value: 134 },
  { id: 224, value: 134 },
  { id: 225, value: 134 },
  { id: 226, value: 134 },
  { id: 227, value: 134 },
  { id: 228, value: 134 },
  { id: 229, value: 134 },
  { id: 230, value: 134 },
  { id: 231, value: 134 },
  { id: 232, value: 134 },
  { id: 233, value: 134 },
  { id: 234, value: 134 },
  { id: 235, value: 134 },
  { id: 236, value: 134 },
  { id: 237, value: 134 },
  { id: 238, value: 134 },
  { id: 239, value: 134 },
  { id: 240, value: 134 },
  { id: 241, value: 134 },
];
export default { yardCity, ID_MAPPING };
